import React, { useState, useEffect, useContext } from 'react';
// import clsx from 'clsx';
// import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid, Button, CircularProgress } from '@material-ui/core';

import { useSelector, useDispatch } from 'react-redux';

import {
  Total,
  Meal,
  MealCounter,
  Customers,
  Payments,
  SelectedMeal
} from './components/';

import { useHistory } from 'react-router-dom';

import { parseISO, format } from 'date-fns';
import _ from 'lodash';

import api from '../../common/apiService';
import helpers from '../../helpers/helpers';
import config from '../../config/config.json';
import OrderContext from '../../context/orderContext';
import withAlert from '../../hoc/withAlert';

import {
  getTicketPriceSelector,
  getTicketPricePaidSelector,
  setTicketSpecialPrice,
  setTicketManualPrice,
  getTicketCouponsSelector,
  resetTicket,
  loadTicket,
  setCoupons,
  setTicketPricePaid,
  setCustomerType
} from '../../store/ticket';

import {
  initPage,
  getRequestErrorsByPageSelector,
  getPageReadyByPageSelector
} from '../../store/api';

const useStyles = makeStyles(theme => ({
  rootInvisible: {
    padding: theme.spacing(4),
    display: 'none'
  },
  root: {
    padding: theme.spacing(4)
  }
}));

const redirectUrl = '/orders';

const Order = props => {
  // Заберем из HOC нужные методы для показа алерта
  const { setSnackMessage, setSnackType, setOpenSnack } = props;
  const classes = useStyles();
  let history = useHistory();
  const orderContext = useContext(OrderContext);

  const [sessions, setSessions] = useState([]);

  const [users, setUsers] = useState([]);
  const [ticketPayments, setTicketPayments] = useState([]);
  const [ticketCoupons, setTicketCoupons] = useState([]);

  // Use only for edit to pass inside payments
  const [ticketStatus, setTicketStatus] = useState();

  // обработчик загрузки всех зависимостей
  const [pageReady, setPageReady] = useState(false);
  // console.log('pageReady',pageReady);

  // Селекторы
  const dispatch = useDispatch();

  // Цена билета
  const ticketPrice = useSelector(getTicketPriceSelector);
  const ticketPricePaid = useSelector(getTicketPricePaidSelector);
  const coupons = useSelector(getTicketCouponsSelector);
  const pageReadyState = useSelector(getPageReadyByPageSelector('/order/new'));
  // console.log('pageReady',pageReadyState);

  // console.log('coupons', coupons);

  const ticketId = props.match.params.id;

  const prepareApiSessions = apiSessions => {
    _.forEach(apiSessions, function(obj) {
      obj.startDate = parseISO(obj.start);
      delete obj.start;
      obj.endDate = parseISO(obj.end);
      delete obj.end;

      const weekends = obj.weekends;
      delete obj.weekends;
      obj.weekends = [];
      _.forEach(weekends, function(w) {
        // console.log(w.date)
        obj.weekends.push(parseISO(w.date));
      });
    });
    return apiSessions;
  };

  const prepareApiUsers = apiUsers => {
    // console.log('prepareApiUsers',apiUsers)
    // const usersNew = _.map(apiUsers, (value, key) => {
    //   return value
    //   // return value.customers
    // });
    // console.log('usersNew prepareApiUsers',usersNew);
    const userList = _.sortBy(_.uniqBy(_.flatten(apiUsers), 'id'), 'id');
    // console.log('userList',userList);
    _.forEach(userList, function(val, ind) {
      userList[ind][
        'label'
      ] = `${userList[ind]['id']}: ${userList[ind]['name']} ${userList[ind]['surname']}`.trim();
      delete userList[ind]['surname'];
      delete userList[ind]['name'];
      userList[ind]['value'] = userList[ind]['id'];
      delete userList[ind]['id'];

      userList[ind]['type'] = helpers.getCustomerType(
        userList[ind]['customertype_id']
      );
      delete userList[ind]['customertype_id'];
    });

    return userList;
  };

  // Обработка загрузки данных с сервера
  useEffect(() => {
    // Получим списки сессий и пользователей
    let mounted = true;

    const getData = async () => {
      // console.log('order useEffect getData');
      await dispatch(resetTicket());
      await initPage('/order/new', dispatch);

      let apiSessions = await api.getSessions();
      apiSessions = prepareApiSessions(apiSessions);
      // console.log(apiSessions)
      setSessions(apiSessions);

      let apiUsers = await api.getUsers();
      apiUsers = prepareApiUsers(apiUsers);
      // console.log(apiSessions)

      // Тперь проверим если есть номер билета то выгрузим данные по нему и инициализируем список выбранных билетов, пользователя и платежи
      if (ticketId === 'new') {
        if (mounted) {
          orderContext.changeActionType('create');
          setUsers({
            users: apiUsers,
            selected: null
          });
        }
        // setPageReady(true)
      } else {
        orderContext.changeActionType({ actionType: 'edit', ticketId });
        // await dispatch(loadTicket(ticketId));
        let ticket = await api.getTicket(ticketId);
        await dispatch(setCoupons(ticket.couponseating, ticket.manual_price));
        // console.log('ticket', ticket);
        // console.log('couponseating ', ticket.couponseating[0].Customer.id);
        // Передадим  пользователя из билета
        if (mounted) {
          // console.log('user',             {
          //   users: apiUsers,
          //   ticketUserId: parseInt(ticket.couponseating[0].Customer.id),
          //   ticketUserType: helpers.getCustomerType(ticket.couponseating[0].customertype_id)

          // });

          setUsers({
            users: apiUsers,
            ticketUserId: parseInt(ticket.couponseating[0].Customer.id),
            ticketUserType: helpers.getCustomerType(
              ticket.couponseating[0].customertype_id
            )
          });
          const customerType = helpers.getCustomerType(
            ticket.couponseating[0].customertype_id
          );

          // console.log('customerType',customerType);
          await dispatch(setCustomerType({ customerType }));

          // Передатим платежи из билета
          setTicketPayments(
            _.map(ticket.payments, (value, key) => {
              return {
                index: key,
                payment: {
                  amount: value.amount,
                  currency: value.Currency.id,
                  type: value.Paymenttype.id
                }
              };
            })
          );
          // console.log('ticketPayments', ticketPayments);
          // Передадим в еду купоны из билета
          setTicketCoupons(ticket.couponseating);

          setTicketStatus(ticket.Ticketstatus.id);
          if (ticket.Ticketstatus.id === 3) {
            setSpecialPrice(ticket.manual_price);
          } else {
            setMealsPrice(ticket.manual_price);
          }
        }
      }

      // console.log('sessions',sessions);
      // setPageReady(true)
    };
    // console.log(format(new Date(),'ddMMyyyyHHmmss'));
    getData();

    // https://www.debuggr.io/react-update-unmounted-component/
    return () => (mounted = false);
  }, []);

  // При изменении айдишника делаем рефреш
  // useEffect(() => {
  //   console.log('props.match.params.id',props.match.params.id)
  //   // window.location.reload();
  // }, [props.match.params.id]);

  const [mealsTypes, setMealsTypes] = useState(config.mealsTypes);

  // Все выбранные обеды
  const [checked, setChecked] = useState([]);

  // Счетчик обедов и стоимости
  const [mealsTypesCounter, setMealsTypesCounter] = useState();
  const [mealsPrice, setMealsPrice] = useState(0);

  const handleChecked = newChecked => {
    setChecked(newChecked);
    changeMealContersAndPrice(newChecked);
  };

  const changeMealContersAndPrice = newChecked => {
    // Посчитаем колво приемов пищи
    // Распакую структуру сделаем плоский массив объектов
    const mealsList = _.values({ ...newChecked })
      .map(t => {
        return _.values(t);
      })
      .reduce((a, b) => a.concat(b), []);

    // console.log('changeMealContersAndPrice mealsList',mealsList);
    const mealsTypesCounterNew = _.reduce(
      { ...mealsTypes },
      function(obj, mt) {
        const ch = _.filter(mealsList, t => {
          return t[mt.id] > 0;
        });
        obj[mt.id] = _.sumBy(ch, mt.id);
        return obj;
      },
      {}
    );

    setMealsTypesCounter(mealsTypesCounterNew);
    changeMealPrice(mealsTypesCounterNew);
  };

  const changeMealPrice = (mtc = []) => {
    // const changeMealPrice = (mtc) => {
    // Если нет специальной цены
    // console.log('changeMealPricec hangeMealPrice', specialPrice, typeof(specialPrice));

    if (specialPrice === '') {
      const customer_type = customer ? customer.type : config.clientType;

      const mealsPriceList = _.map(mtc, (value, key) => {
        const mt = _.filter(mealsTypes, ml => {
          return parseInt(ml.id) === parseInt(key);
        })[0];
        // console.log('changeMealPrice', mt, customer_type, config.priceRulesByCustomerType[customer_type]);
        // return value * mt.price * config.priceRulesByCustomerType[customer_type][mt.type]
        return value * config.priceRulesByCustomerType[customer_type][mt.type];
      });

      const mealsPriceNew = _.sum(mealsPriceList);
      setMealsPrice(mealsPriceNew);
    } else {
      setMealsPrice(parseInt(specialPrice));
    }
  };

  // Хендлеры для кастомеров
  const [customer, setCustomer] = useState(false);

  const handleCustomerChange = customerNew => {
    setCustomer(customerNew);
    // changeMealPrice(mealsTypesCounter, customerNew)
  };

  useEffect(() => {
    // console.log('useEffect customer',mealsTypesCounter);
    changeMealPrice(mealsTypesCounter);
  }, [customer]);

  // Для платежей
  const [payments, setPayments] = useState([]);
  const [payedStatus, setPayedStatus] = useState('unpayd');
  const [currentPaymentAmount, setCurrentPaymentAmount] = useState(0);

  const handleChangePayment = paymentsNew => {
    setPayments(paymentsNew);
  };

  const handleChangePayedStatus = payedStatusNew => {
    setPayedStatus(payedStatusNew);
  };
  const handleChangeСurrentPaymentAmount = async currentPaymentAmountNew => {
    // console.log('handleChangeСurrentPaymentAmount', currentPaymentAmountNew);
    // console.log('handleChangeСurrentPaymentAmount',currentPaymentAmountNew);
    // await dispatch(setTicketPricePaid({pricePaid: currentPaymentAmountNew}))
    setCurrentPaymentAmount(currentPaymentAmountNew);
    // setCurrentPaymentAmount(ticketPricePaid)
  };

  // useEffect(() => {

  // }, [checked]);

  // Отправка тикета на сервер
  const handleCreateTicket = async () => {
    setSending(true);

    // const mc = _.sum(_.values(mealsTypesCounter))
    // if (mc === 0) {

    if (coupons.filter(c => c.amount > 0).length === 0) {
      setSnackMessage('Не выбранны обеды');
      setSnackType('error');
      setOpenSnack(true);
      setSending(false);

      return;
    }

    if (customer === false) {
      setSnackMessage('Не выбранн участник');
      setSnackType('error');
      setOpenSnack(true);
      // setErrorMessage("Не выбранн участник")
      // setOpen(true);
      setSending(false);

      return;
    }
    // console.log('handleCreateTicket payments', payments, customer)
    // console.log('customer.type',customer.type)
    // console.log('payments',payments,_.isEmpty(payments))

    if (_.isEmpty(payments)) {
      setSnackMessage('Не введены платежи');
      setSnackType('error');
      setOpenSnack(true);
      setSending(false);

      // setErrorMessage("Не введены платежи")
      // setOpen(true);
      return;
    }

    // return

    // // Соберем список питания в нужно формате и только для выбранных элементов
    // let checkedMeal = []
    // _.forEach(checked, function (sessionsDates, sessionId) {
    //   _.forEach(sessionsDates, function (dateMeals, date) {
    //     _.forEach(dateMeals, function (mealState, mealId) {
    //       if (mealState > 0) {
    //         checkedMeal.push({ sessionId, date, mealId, amount: mealState });
    //       }
    //     });
    //   });
    // });

    const paymentsPrepared = _.map(payments, (value, key) => {
      return value.payment;
    });

    const ticket = {
      customer,
      payments: paymentsPrepared,
      checkedMeal: coupons.filter(c => c.amount > 0),
      payedStatus: customer.type === 2 ? 3 : payedStatus,
      currentPaymentAmount,
      created_at: format(new Date(), 'ddMMyyyyHHmmss')
    };
    console.log('handleCreateTicket ticket', ticket);
    // return
    try {
      const res = await api.createTicket(ticket);
      // console.log('handleCreateTicket res',res)
      if (res.status === 200) {
        setSnackMessage('Билет успешно создан');
        setSnackType('success');
        setOpenSnack(true);
        setTimeout(async () => {
          await dispatch(resetTicket());
          history.replace(redirectUrl);
        }, 1000);
      } else {
        setSnackMessage('Ошибка. Билет не создан');
        setSnackType('error');
        setOpenSnack(true);
        setSending(false);
      }
    } catch (error) {
      setSnackMessage(`Ошибка: ${error}`);
      setSnackType('error');
      setOpenSnack(true);
      setSending(false);
    }
  };

  const [specialPrice, setSpecialPrice] = React.useState('');
  const handleSpecialPrice = async price => {
    // console.log('order handleSpecialPrice', price);
    setSpecialPrice(price);
    if (orderContext.actionType === 'edit') {
      await dispatch(setTicketManualPrice(ticketId, price));
    } else {
      await dispatch(setTicketSpecialPrice({ specialPrice: price }));
    }
    // changeMealPrice()
  };

  useEffect(() => {
    changeMealPrice(mealsTypesCounter);
    // setPageReady(true)
  }, [specialPrice]);

  // Обработчик нажатия кнопки
  const [sending, setSending] = useState(false);

  // console.log('sessions component',sessions);
  return (
    <React.Fragment>
      {/* <Snackbar open={openSnack} autoHideDuration={3000} onClose={handleCloseSnack}>
        <Alert onClose={handleCloseSnack} severity={snackType}>
          {snackMessage}
        </Alert>
      </Snackbar> */}
      {pageReadyState === false && (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <CircularProgress disableShrink size={56} />
        </div>
      )}

      <div className={pageReadyState ? classes.root : classes.rootInvisible}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Grid
              container
              direction="column"
              justify="flex-start"
              alignItems="stretch"
              spacing={3}>
              <Grid
                item
                xs={12}
                style={{
                  position: '-webkit-sticky',
                  position: 'sticky',
                  top: 62,
                  overflow: 'visible',
                  zIndex: 100
                }}>
                <Grid
                  container
                  direction="row"
                  justify="flex-start"
                  alignItems="stretch"
                  spacing={1}>
                  <Grid item xs={2}>
                    <Total
                      price={ticketPrice}
                      name="Стоимость"
                      onSetSpecialPrice={handleSpecialPrice}
                      specialprice={specialPrice}
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <Total
                      price={
                        orderContext.actionType === 'edit'
                          ? ticketPricePaid
                          : currentPaymentAmount
                      }
                      // price={ticketPricePaid}
                      name="Оплатил"
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <MealCounter
                      conter={
                        mealsTypesCounter
                          ? mealsTypesCounter[
                              _.filter(config.mealsTypes, [
                                'name',
                                'Завтрак'
                              ])[0].id
                            ]
                          : 0
                      }
                      name="Завтраков"
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <MealCounter
                      conter={
                        mealsTypesCounter
                          ? mealsTypesCounter[
                              _.filter(config.mealsTypes, ['name', 'Обед'])[0]
                                .id
                            ]
                          : 0
                      }
                      name="Обедов"
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <MealCounter
                      conter={
                        mealsTypesCounter
                          ? mealsTypesCounter[
                              _.filter(config.mealsTypes, ['name', 'Ужин'])[0]
                                .id
                            ]
                          : 0
                      }
                      name="Ужинов"
                    />
                  </Grid>

                  <Grid item xs={2}>
                    <Grid
                      container
                      direction="column"
                      justify="flex-start"
                      alignItems="flex-start"
                      spacing={2}>
                      <Grid item xs={12}>
                        {props.match.params.id === 'new' && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleCreateTicket}
                            disabled={sending}>
                            Сохранить
                          </Button>
                        )}
                      </Grid>

                      <Grid item xs={12}>
                        {props.match.params.id === 'new' && sending && (
                          <CircularProgress
                            disableShrink
                            style={{ display: 'block' }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  justify="flex-start"
                  alignItems="flex-start"
                  spacing={3}>
                  <Grid item xs={5}>
                    <Meal
                      sessions={sessions}
                      mealsTypes={mealsTypes}
                      onChecked={handleChecked}
                      coupons={ticketCoupons}
                    />
                  </Grid>

                  <Grid item xs={7}>
                    <Grid
                      container
                      direction="column"
                      justify="flex-start"
                      alignItems="stretch"
                      spacing={3}>
                      <Grid item xs={12}>
                        <Customers
                          onCustomerChange={handleCustomerChange}
                          users={users}
                          setPageReady={setPageReady}
                          ticketId={ticketId}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      direction="column"
                      justify="flex-start"
                      alignItems="stretch"
                      spacing={3}>
                      <Grid item xs={12}>
                        <SelectedMeal />
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      direction="column"
                      justify="flex-start"
                      alignItems="stretch"
                      spacing={3}>
                      <Grid item xs={12}>
                        <Payments
                          price={ticketPrice}
                          ticketStatus={ticketStatus}
                          onChangePayment={handleChangePayment}
                          onChangePayedStatus={handleChangePayedStatus}
                          onChangeСurrentPaymentAmount={
                            handleChangeСurrentPaymentAmount
                          }
                          ticketPayments={ticketPayments}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
};

// Перезагружаем страницу если перешли на другой билет или на создание нового билета
function renderRool(prevProps, nextProps) {
  // console.log('renderRool',prevProps.match.params.id,nextProps.match.params.id);
  if (
    prevProps.match.params.id &&
    prevProps.match.params.id !== nextProps.match.params.id
  ) {
    window.location.reload();
  }
}

export default React.memo(withAlert(Order), renderRool);
